<template>

    <div class="paymybill-content" id="parent">
        <section class="mb-5">
            <div class="container">
                <div class="heading-title">
                    <span>Customs & Border Protection Payment</span>
                </div>

                <Aircraft v-show="store.currentPage == 'AIRCRAFT'" @goToPage="goToPage"></Aircraft>
                <Payment v-show="store.currentPage == 'PAYMENT'" @goToPage="goToPage" @goBackToPage="goBackToPage" :visible="store.currentPage == 'PAYMENT'"></Payment>
                <Review v-show="store.currentPage == 'REVIEW'" @goToPage="goToPage" @goBackToPage="goBackToPage"></Review>
                <Finish v-show="store.currentPage == 'FINISH'"></Finish>
            </div>
        </section>
    </div>
</template>

<script setup>
    import { useStore } from './store';
    import Aircraft from './aircraft';
    import Payment from './payment';
    import Review from './review';
    import Finish from './finish';

    const store = useStore();

    function goToPage(page) {

        if (page != 'AIRCRAFT') {
            store.currentPage = page;
        }
    }

    function goBackToPage(page) {
        store.currentPage = page;
    }

</script>